import { Helmet } from "react-helmet"
import BannerContacto from "../components/BannerContacto"
import Footer from "../components/Footer"
import NavBar from "../NavBar"
import NavBarTop from "../NavBarTop"
import env from '../config';
import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import data from '../data/vehicleData.js';
import { CenterContact } from "../components/CenterContact.jsx"
import FooterSinWp from "../components/FooterSinWp.jsx"
import ContactoTecnico from "../components/ContactoTecnico.jsx"
import { NavLink } from "react-router-dom"

let urlMedia = env.url



export const Pqrs = () => {

    return (
        <>
            <Helmet>
                <title>Pqrs | Vehicentro</title>
                <meta name="description" content="Pqrs" />
            </Helmet>
            <NavBarTop />
            <div className="ContenedorContac">
                <img className="contactoFoto" src={urlMedia + "/PQRS/Servicio.webp"} alt="" title="" />
            </div>
            <div className="ContenedorContacCelu">
                <img className="contactoFoto" src={urlMedia + "/PQRS/Servicio_celular.webp"} alt="" title="" />
            </div>
            <div className="contenedorSeguridad">
                <div className="contenedorTextoSeguridad titulo">
                    <h1 className="tituloprincipalPQR">Peticiones, Quejas, Reclamos y Sugerencias</h1>
                    <br />
                    <div className="contenedorTextoSeguridadInterno justificado">
                        <p>
                            Apreciado cliente
                        </p>
                        <br />
                        <p>
                            Por disposición de la Superintendencia de Industria y Comercio, Vehicentro Colombia S.A.S.,
                            cuentan con un mecanismo institucional de recepción y trámite de las peticiones, quejas y
                            reclamos sobre los productos y servicios prestados. De esta manera, se designó un responsable
                            institucional para la recepción y trámite de PQR’S, quien atenderá sus inquietudes y
                            reclamaciones en la dirección Cra 126A N° 17 - 50. También podrá contactase a través de los
                            siguientes canales:
                        </p>
                        <br />
                        <CenterContact />
                    </div>
                </div>
                <br />
                <h2 className="tituloPQR">Estados por los que debe pasar su solicitud</h2>
                <div className="ContenedorContac">
                    <img className="contactoFoto" src={urlMedia + "/PQRS/PQRS.webp"} alt="" title="" />
                </div>
                <div className="ContenedorContacCelu">
                    <img className="contactoFoto" src={urlMedia + "/PQRS/PQRS_Celular.webp"} alt="" title="" />
                </div>
                <div className="contenedorBotonones">
                    <div className="resgistrarSolicitud">
                        <NavLink id="1" className="registraSolButton1" to="/infoPqr">
                            Registar Solicitud
                        </NavLink>
                    </div>
                </div>

                <br />
            </div>
            <ToastContainer />
            <BannerContacto />
            <Footer />
        </>
    )
}
